module.exports = __webpack_public_path__ + "img/est07.5078532f.png";